import Splide from '@splidejs/splide';
import { minMediaQueryXL } from 'PlugAndPlay/_global/js/screenSize';

export default function _imageSlider() {
    /**
     * image slide wrapper selector
     * @const {string}
     */
    const SLIDER_SELECTOR = '[data-component="image-slider"]';

    /**
     * targets autoplay button when off
     * @const {string}
     */
    const SLIDER_AUTOPLAY_OFF = '[data-component="toggle-autoplay-off"]';

    /**
     * selects type when set to loop
     * @const {string}
     */
    const TYPE_LOOP = '[data-type="loop"]';

    /**
     * selects type when set to slide
     * @const {string}
     */
    const TYPE_SLIDE = '[data-type="slide"]';

    // function to target autplay button when off.
    const autoplayToggle = (slider) => {
        const autoPlayOff = !!slider.querySelector(SLIDER_AUTOPLAY_OFF);
        const toggleButton = slider.querySelector(SLIDER_AUTOPLAY_OFF);
        // toggles to on at page load if enabled.
        if (autoPlayOff) {
            window.onload = function () {
                toggleButton.click();
            };
        }
    };

    // all carousel instances
    const allSliders = document.querySelectorAll(SLIDER_SELECTOR);

    // desktop media breakpoint number extracted
    const screenXL = Number(minMediaQueryXL.replace(/\D/g, ''));

    // fire up splide library
    const initialiseSlider = () => {
        allSliders.forEach((slider) => {
            // target type of slider selected
            const typeLoop = slider.dataset.type;
            // assign 'loop' or 'slide' value to sliderType variable
            let sliderType;
            if (typeLoop === 'slide') {
                sliderType = 'slide';
            } else sliderType = 'loop';

            new Splide(slider, {
                type: sliderType,
                heightRatio: 0.5533,
                pagination: false,
                speed: 1000,
                dragMinThreshold: 10,
                autoplay: true,
                interval: 3500,
                mediaQuery: 'min',
                breakpoints: {
                    [screenXL]: {
                        drag: false,
                        heightRatio: 0.5631,
                    },
                },
            }).mount();
            // pass each processed instance to autoplay toggle function
            autoplayToggle(slider);
        });
    };

    /**
     * @const {boolean}
     */
    const sliderExists = !!document.querySelector(SLIDER_SELECTOR);

    // If the module exists, do whatever we need to
    if (sliderExists) {
        initialiseSlider();
    }
}

// calls the carousel function
_imageSlider();
